import { styled } from 'theme';

export const MapContComp = styled('div')(() => ({
    flex: '1 1 auto',
}));
